import { render, staticRenderFns } from "./AssignRole.vue?vue&type=template&id=0ca7294c&scoped=true"
import script from "./AssignRole.vue?vue&type=script&lang=js"
export * from "./AssignRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca7294c",
  null
  
)

export default component.exports